import {
  GeoJSON,
  useMap,
} from '@manifesto-tech/react-leaflet';
import React, {useEffect, useRef, useState} from 'react';
import * as turf from '@turf/turf';
import L from 'leaflet';

const MapBoundary = ({locationData}) => {
  const globalRect = [
    [-172.96875, -85.051129],
    [-172.96875, 85.051129],
    [205.3125, 85.051129],
    [205.3125, -85.051129],
    [-172.96875, -85.051129],
  ];
  const map = useMap();
  const boundaryLayer = useRef(null);
  const [bounds, setBounds] = useState({});
  const [boundaryInvert, setBoundaryInvert] = useState({});
  const [boundaryGeoData, setBoundaryGeoData] = useState({});
  const [loadingInitialGeoData, setLoadingInitialGeoData] = useState(true);
  const [loadingBoundaryInvert, setLoadingBoundaryInvert] = useState(true);
  const [resizeEnd, setResizeEnd] = useState(setTimeout(() => false))

  const resetView = () => {
    const zoomStart = map.getZoom();
    const minZoom = zoomStart - 0.1;
    map.fitBounds(bounds);
    map.setMaxBounds(bounds);
    map.setMinZoom(minZoom);
    map.setZoom(zoomStart);
  }

  useEffect(() => {
    if (Object.keys(locationData.features).length > 0) {
      let coordinates = [];

      turf.featureEach(locationData, (feature, featureIndex) => {
        const featureType = turf.getType(feature);

        if (featureType === 'Polygon') {
          setBoundaryGeoData(feature);
          coordinates = turf.getCoords(feature);
        }
      });
    }
  }, [locationData]);

  useEffect(() => {
    if (boundaryGeoData?.geometry) {
      setLoadingInitialGeoData(false);
    }
  }, [boundaryGeoData]);

  useEffect(() => {
    if (!loadingInitialGeoData) {
      if (boundaryLayer.current) {
        setBounds(boundaryLayer.current.getBounds());
      }
    }
  }, [loadingInitialGeoData]);

  useEffect(() => {
    if (Object.keys(bounds).length > 0) {
      const boundaryRect = L.rectangle(globalRect).toGeoJSON();

      resetView();

      if (boundaryRect.geometry && boundaryGeoData.geometry) {
        const boundaryRectPolygon = turf.getGeom(boundaryRect);
        const boundaryLayerPolygon = turf.getGeom(boundaryGeoData);
        const diff = turf.difference(boundaryRectPolygon, boundaryLayerPolygon);
        setBoundaryInvert(diff);
      }

      if (map) {
        map.on('resize', () => {
          clearTimeout(resizeEnd);
          setResizeEnd(
            setTimeout(() => {
              resetView();
            }, 500)
          );
        });
      }
    }
  }, [bounds]);

  useEffect(() => {
    if (boundaryInvert.geometry) {
      setLoadingBoundaryInvert(false);
      setBoundaryGeoData(boundaryInvert);
    }
  }, [boundaryInvert]);

  return (
    <>
      {!loadingBoundaryInvert && (
        <GeoJSON
          data={boundaryInvert}
          pathOptions={{
            fillColor: 'black',
            fillOpacity: 0.4,
            stroke: 0,
          }}
        />
      )}

      {!loadingInitialGeoData &&
        <GeoJSON
          ref={boundaryLayer}
          data={boundaryGeoData}
          pathOptions={{
            fillOpacity: 0,
            stroke: 0,
          }}
        />
      }
    </>
  );
}

export default MapBoundary;
